var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('router-link',{attrs:{"to":_vm.homeUrl}},[_c('span',[_vm._v("shop by")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }